<template>
  <div style="display: flex; justifycontent: center">  
    <div v-if="row.automatic_verification_status == 1" style="display:flex">
      <div>
        <Icon
          class="icon"
          type="md-checkmark"
          size="12"
          color="#35C030"
          style="marginRight: 3px"
        />
      </div>
      <div>
        <span>Passed all</span>
      </div>
    </div>
    <div v-if="row.automatic_verification_status !== 1" style="display:flex">
      <div>
        <Icon
          class="icon"
          type="md-close"
          size="12"
          color="red"
          style="marginRight: 5px"
        />
      </div>
      <div>
       <span>{{row.kyc ? row.kyc.rejection_reason ? row.kyc.rejection_reason : "Not verified" : 'Not Verified'}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
    },
  },



}
 
</script>

<style lang="scss" scoped>
</style>

